import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFillPathway } from '../../../../contexts/fill/use-fill-prescription';
import type { SwitchRequestSource } from '../../../../types/drug-config';
import { getRouteForReturnScreen } from '../../../../util/get-route-for-return-screen';

export const useKeepCurrent = (
    drxId: string,
    requestSource: SwitchRequestSource
) => {
    const { previousPathway, previousSubPathway } = useFillPathway();
    const navigate = useNavigate();
    const { keepCurrent } = requestSource;

    return useCallback(() => {
        const { returnPathway, returnSubPathway, returnScreen } = keepCurrent;

        const actualReturn =
            returnPathway === 'previous' ? previousPathway : returnPathway;
        const actualReturnSub =
            returnSubPathway === 'previous'
                ? previousSubPathway
                : returnSubPathway;

        const search = actualReturnSub
            ? `?pathway=${actualReturn}&sub-pathway=${actualReturnSub}`
            : `?pathway=${actualReturn}`;

        navigate({
            pathname: getRouteForReturnScreen(drxId, returnScreen),
            search,
        });
    }, [drxId, keepCurrent, navigate, previousPathway, previousSubPathway]);
};
